// Lessons_card.js
import React from 'react';
import "./Lessons_card.css";

function Lessons_card({ imgSrc, title, description, duration, outcome }) {
    return (
        <section className='Lessons_card'>
            <div className="img_text_holder">
                <div className="img_holder">
                    <img src={imgSrc} alt={title} className='card_img' />
                </div>
                <div className="name_holder">
                    <p>{title}</p>
                </div>
            </div>
            <div className="text_holder">
                <p>{description}</p>
                {/* <br />
                <p><span>Duration:</span> <br />{duration}</p>
                <p><span>Outcome:</span> <br />{outcome}</p> */}
            </div>
        </section>
    );
}

export default Lessons_card;
